import { useState } from 'react';
import ClearableInput from 'components/common/ClearableInput/ClearableInput';

/**
 * Examples of ClearableInput.
 */

function ClearableInputExamplePage(): JSX.Element {
  const [text, setText] = useState('Click clear to clear this input');

  const handleChange = (value: string): void => {
    setText(value);
  };

  return (
    <section id="clearableInput" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">ClearableInput</h1>
      <div className="ExamplesPage__Description">
        This component is a text input that has an optional button for clearing content.
      </div>
      <div className="ExamplesPage__ExampleRow">
        <ClearableInput onChange={handleChange} value={text} />
      </div>
    </section>
  );
}

export default ClearableInputExamplePage;
